import React, { Component } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { compose } from "redux"
import { toast } from "react-toastify"
import { translate } from "react-i18next"
import { ENVIRONMENT, CUSTOMREPORTENDPOINTS } from "../../../constants"
import { Button } from "../../themed-html-components"
import { downloadFile } from "../../../utils/file-utils"
import WidgetExportDownloadNotification from "../../layout/widget/WidgetExportDownloadNotification" // eslint-disable-line
import WidgetExportDownloadCompleteNotification from "../../layout/widget/WidgetExportDownloadCompleteNotification" // eslint-disable-line
import WidgetExportDownloadErrorNotification from "../../layout/widget/WidgetExportDownloadErrorNotification" // eslint-disable-line

class ReportDownloadButton extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,
    access_token: PropTypes.string.isRequired,
    reportId: PropTypes.number.isRequired
  }

  componentWillMount = () => {
    this.toastId = null
  }

  onStart = () => {
    this.toastId = toast(<WidgetExportDownloadNotification />, {
      hideProgressBar: true,
      className: "download-notification",
      autoClose: false
    })
  }

  onDownloadComplete = () => {
    toast.update(this.toastId, {
      render: <WidgetExportDownloadCompleteNotification />,
      autoClose: 3500
    })
  }

  onFail = () => {
    toast.update(this.toastId, {
      render: <WidgetExportDownloadErrorNotification />,
      autoClose: 3500
    })
  }

  onDownloadClick = () => {
    const apiUrl = `${ENVIRONMENT.getApiRootUrl()}${CUSTOMREPORTENDPOINTS.Download}?reportId=${
      this.props.reportId
    }`

    if (apiUrl) {
      this.toastId = null

      downloadFile(
        apiUrl,
        [],
        this.props.access_token,
        this.onStart,
        this.onDownloadComplete,
        this.onFail
      )
    }
  }

  render() {
    const { t, label } = this.props

    return <Button onClick={this.onDownloadClick}>{t(label)}</Button>
  }
}

function mapStateToProps(state) {
  return {
    access_token: state.oidc.user.access_token
  }
}

export default compose(translate(), connect(mapStateToProps))(ReportDownloadButton)


// WEBPACK FOOTER //
// ./src/components/custom-report/ReportRequestsTab/ReportDownloadButton.jsx